const LOAD_DATA_MASTER_INSTITUTION         = 'LOAD_DATA_MASTER_INSTITUTION'
const LOAD_DATA_MASTER_INSTITUTION_SUCCESS = 'LOAD_DATA_MASTER_INSTITUTION_SUCCESS'
const LOAD_DATA_MASTER_INSTITUTION_FAILED  = 'LOAD_DATA_MASTER_INSTITUTION_FAILED'
const UNMOUNT_DATA_MASTER_INSTITUTION      = 'UNMOUNT_DATA_MASTER_INSTITUTION'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const institutionReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_INSTITUTION:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_INSTITUTION_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_INSTITUTION_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_INSTITUTION:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default institutionReducer